export default "__VITE_ASSET__IzjHhfaI__"